export default __webpack_public_path__ + "static/media/LoCelso.d7436d3d.jpg";